import { useQuery } from "relay-hooks";
import { graphql } from "babel-plugin-relay/macro";
import { grammarFeedbackQuery } from "./__generated__/grammarFeedbackQuery.graphql";
import { AssistantMode } from "components/assistant/__generated__/AssistantMutation.graphql";

const GrammarFeedbackQuery = graphql`
  query grammarFeedbackQuery($text: String!, $context: String, $language: String, $mode: AssistantMode) {
    grammarFeedback(text: $text, context: $context, language: $language, mode: $mode) {
      correctedText
      score
      detectedLanguage
    }
  }
`;

export const useGrammarFeedback = (
  text: string | undefined,
  context?: string,
  language?: string,
  mode?: AssistantMode,
  { skip }: { skip?: boolean } = { skip: false }
) => {
  const shouldSkip = skip === true || !text;
  const { data, error, isLoading, retry } = useQuery<grammarFeedbackQuery>(
    GrammarFeedbackQuery,
    {
      text: text || "",
      context: context || null,
      language: language || null,
      mode: mode || null
    },
    { skip: shouldSkip }
  );

  const grammarFeedback = data?.grammarFeedback;

  const messageLangMismatch = !!(
    grammarFeedback?.detectedLanguage &&
    language &&
    grammarFeedback.detectedLanguage !== language
  );

  const needRetry = !!error || (!grammarFeedback?.detectedLanguage && !grammarFeedback?.score);

  return {
    feedback: shouldSkip ? undefined : grammarFeedback,
    error,
    messageLangMismatch,
    needRetry,
    isLoading,
    retry
  };
};

type ArgsForContextCreation = {
  prevMessageText: string;
  assistantMode: AssistantMode;
};

export const createGrammarFeedbackContext = ({ prevMessageText, assistantMode }: ArgsForContextCreation) => {
  let context = "";

  if (prevMessageText) {
    context += `Previous message: ${prevMessageText}`;
  }

  if (assistantMode === "letsPractise") {
    context += `INFO: The user is working on a fill-in-the-blank exercise where they need to complete missing word in sentences.`;
  }

  return context;
};
